import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
const FetchDossierIAssureController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierIAssureController.url(args, options),
    method: 'get',
})

FetchDossierIAssureController.definition = {
    methods: ["get","head"],
    url: '/api/dossier/{dossier}/iassure',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
FetchDossierIAssureController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return FetchDossierIAssureController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
FetchDossierIAssureController.get = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FetchDossierIAssureController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Dossier\Partners\FetchDossierIAssureController::__invoke
* @see app/Http/Controllers/Dossier/Partners/FetchDossierIAssureController.php
* @route '/api/dossier/{dossier}/iassure'
*/
FetchDossierIAssureController.head = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FetchDossierIAssureController.url(args, options),
    method: 'head',
})

export default FetchDossierIAssureController